import { supabase } from '@/lib/supabaseClient';

export const requireAuth = async (): Promise<boolean> => {
  try {
    const { data } = await supabase.auth.getSession();
    return !!data.session;
  } catch {
    // Network unavailable (e.g. Supabase project paused)
    return false;
  }
};